package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.QualityState
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun QualityAccordionContent(
    onComplete: (String) -> Unit,
    onAddCompetenceAndClose: (String) -> Unit,
) {
    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState
    val qualitiesFromVM = cvUiState.data.qualities

    LaunchedEffect(Unit) {
        if (qualitiesFromVM.isEmpty()) {
            cvViewModel.updateQuality(0, "")
            cvViewModel.editingQualityId = "quality-0"
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        qualitiesFromVM.forEachIndexed { index, qualityText ->
            val tempId = "quality-$index"

            val state = remember(qualityText) {
                QualityState(id = tempId, quality = qualityText)
            }

            GenericFormCard(
                item = state,
                isEditing = cvViewModel.editingQualityId == tempId,
                onEdit = { cvViewModel.editingQualityId = tempId },
                onDelete = {
                    cvViewModel.deleteQuality(index)
                    if (cvViewModel.cvUiState.data.qualities.isEmpty()) {
                        cvViewModel.updateQuality(0, "")
                        cvViewModel.editingQualityId = "quality-0"
                    } else {
                        cvViewModel.editingQualityId = null
                    }
                },
                onComplete = { cvViewModel.editingQualityId = null },
                getSummary = { q ->
                    if (q.quality.isNotBlank()) {
                        SummaryData(title = q.quality, subtitle = "")
                    } else null
                },
                getDefaultText = { "[Qualité]" },
                formContent = { s, onDel, onComp ->
                    QualityForm(
                        index = index,
                        state = s,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp,
                    )
                }
            )
        }
        AddButton(
            text = "Ajouter une qualité",
            onClick = {
                val nextIndex = qualitiesFromVM.size
                cvViewModel.updateQuality(nextIndex, "")
                cvViewModel.editingQualityId = "qualite-$nextIndex"
            }
        )
    }
}